/**
 * 判断当前是否在 iframe 中
 * @returns {boolean}
 */
export function isInFrame () {
  return window.self !== window.top
}

/**
 * 获取 iframe 的父级窗口
 * @returns {Window}
 */
export function getParentWindow () {
  return window.parent
}

/**
 * 向父级窗口发送消息
 * @param message {any} 消息内容
 */
export function sendMessageToParent (message: any) {
  const isTest = process.env.STAGE === 'test' || process.env.NODE_ENV === 'development'
  // TODO: 正式环境需要配置允许的域名
  const allowOrigins = isTest ?
    ['*'] :
    [
      'https://kantu-web.knfastpic.com',
      'https://knfastpic.singdown.com',
      'https://knfastpic.xgnoxm.cn'
    ]

  if (isInFrame()) {
    allowOrigins.forEach(origin => {
      getParentWindow().postMessage(message, origin)
    })
  }
}
